import React from 'react';
import momentTz from 'moment-timezone';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import PropTypes from 'prop-types';
import quietTimePropType from '../../../../../utility/PropTypes/quietTimePropType';
import TimePeriodFormGroup from './TimePeriodFormGroup/TimePeriodFormGroup';
import { defaultTimePeriod } from '../../../../hooks/useQuietTimes/useQuietTimes';
import { timePeriodTypes } from '../../../../../utility/types/TimePeriodTypes';

function QuietTimeForm({ updateQuietTime, quietTime }) {
  const handleTimezoneChange = (e) => {
    const { value } = e.target;
    updateQuietTime('timezone', value);
  };

  const handleAddTimePeriod = () => {
    const updatedQuietTime = {
      ...quietTime,
      quietTimeScheduleTimePeriodList: [
        ...quietTime.quietTimeScheduleTimePeriodList,
        defaultTimePeriod,
      ],
    };
    updateQuietTime('quietTimeScheduleTimePeriodList', updatedQuietTime.quietTimeScheduleTimePeriodList);
  };

  const handleTimePeriodChange = (updatedTimePeriod, rowIndex) => {
    const isEveryDaySelected = updatedTimePeriod.startTimePeriodTypeId === timePeriodTypes.ALL
      && updatedTimePeriod.endTimePeriodTypeId === timePeriodTypes.ALL;

    const previousTimePeriod = quietTime.quietTimeScheduleTimePeriodList[rowIndex];
    const wasEveryDaySelected = previousTimePeriod
      && previousTimePeriod.startTimePeriodTypeId === timePeriodTypes.ALL
      && previousTimePeriod.endTimePeriodTypeId === timePeriodTypes.ALL;

    const finalTimePeriod = isEveryDaySelected && !wasEveryDaySelected
      ? {
        ...updatedTimePeriod,
        startHours: 0,
        startMinutes: 0,
        endHours: 23,
        endMinutes: 59,
      }
      : updatedTimePeriod;

    const updatedTimePeriodList = quietTime.quietTimeScheduleTimePeriodList
      .map((timePeriod, index) => (rowIndex === index ? finalTimePeriod : timePeriod));
    updateQuietTime('quietTimeScheduleTimePeriodList', updatedTimePeriodList);
  };

  const handleDeleteTimePeriod = (rowIndex) => {
    const updatedTimePeriodList = quietTime.quietTimeScheduleTimePeriodList
      .filter((timePeriod, index) => index !== rowIndex);
    updateQuietTime('quietTimeScheduleTimePeriodList', updatedTimePeriodList);
  };

  return (
    <div className="container-fluid">
      <div className="col-12">
        <div className="form-group row mb-4">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label className="col-form-label col-auto">Timezone</label>
          <div className="col-auto">
            <select
              className="form-control"
              aria-label="select timezone"
              onChange={handleTimezoneChange}
              value={quietTime.timezone}
            >
              <option value="" disabled>-- Select a Time Zone --</option>
              { momentTz.tz.names().map((timezoneName) => (
                <option key={timezoneName} value={timezoneName}>{timezoneName}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="form-label row-col mb-3">
          Silence (skip) alert actions during the following times:
        </div>
        <div className="row">
          <div className="col-form-label col-auto" />
          <div className="col-auto">
            <div className="mb-2">
              { quietTime.quietTimeScheduleTimePeriodList.map((timePeriod, index) => (
                <div key={`time-period-${index}`}>
                  <TimePeriodFormGroup
                    currentTimePeriod={timePeriod}
                    timePeriodRowIndex={index}
                    handleUpdateTimePeriod={(data) => handleTimePeriodChange(data, index)}
                    handleDeleteTimePeriod={(data) => handleDeleteTimePeriod(data, index)}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <button type="button" className="mt-2 btn btn-sm btn-secondary" onClick={handleAddTimePeriod}>
              <Icon icon="plus" />
              &nbsp;
              Add time period
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
QuietTimeForm.propTypes = {
  updateQuietTime: PropTypes.func.isRequired,
  quietTime: PropTypes.shape(quietTimePropType).isRequired,
};
export default QuietTimeForm;
